import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/car-attendance-currents', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getHistory = (options = {}) => {
  return httpClient
    .get('/api/car-attendance-histories', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getdriverByVehicle = (options = {}) => {
  return httpClient
    .get('/api/car-attendances/get-driver-by-vehicles', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, getdriverByVehicle, getHistory }
